/**
 * Cosmic Size Guide Toggle Engine
 * Premium Modal Interactions
 */

class CosmicSizeGuide {
  constructor() {
    this.trigger = document.getElementById('size-guide-trigger');
    this.modal = document.getElementById('cosmic-size-guide-modal');
    this.closeBtn = document.getElementById('size-guide-close');

    if (!this.trigger || !this.modal || !this.closeBtn) return;

    this.init();
  }

  init() {
    this.trigger.addEventListener('click', () => this.open());
    this.closeBtn.addEventListener('click', () => this.close());
    
    // Close on backdrop click
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('active');
    this.modal.style.opacity = '';
    this.modal.style.visibility = '';
    document.body.style.overflow = 'hidden'; // Prevent scroll
  }

  close() {
    this.modal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scroll
  }
}

// Global initialization
document.addEventListener('DOMContentLoaded', () => {
  window.cosmicSizeGuideInstance = new CosmicSizeGuide();
});
